import PropTypes from 'prop-types';

import { cn } from '#/lib/utils';
import {
  formatCostEstimateDecimal,
  formatCostEstimateRoundingMode,
  formatCostEstimateTotal,
} from '#/modules/crmMgmt/costEstimate/helper/costEstimateFormat';
import { formatDateTimeOrDash } from '#/utils/date';

function InfoField({ label, value, wide = false }) {
  return (
    <div className={cn(wide && 'sm:col-span-2 md:col-span-2')}>
      <p className="text-xs text-gray-500">{label}</p>
      <p className="mt-0.5 text-sm font-medium wrap-break-word text-gray-900">{value}</p>
    </div>
  );
}

InfoField.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.node.isRequired,
  wide: PropTypes.bool,
};

/** 成本試算表頭：名稱、取整、金額摘要與備註。 */
const CostEstimateMainInfoCard = ({ detail, actions = null, compact = false }) => (
  <div className="receipt-card-elevate">
    <div className={cn('receipt-card-surface', compact ? 'p-4' : 'p-5')}>
      <div className="flex flex-wrap items-start justify-between gap-3">
        <div className="min-w-0 flex-1">
          <div className="flex flex-wrap items-center gap-2">
            <h1 className={cn('font-bold text-gray-900', compact ? 'text-xl' : 'text-2xl')}>
              {detail.name || '-'}
            </h1>
          </div>
        </div>
        {actions ? (
          <div className="flex shrink-0 flex-wrap items-center justify-end gap-2">
            {actions}
          </div>
        ) : null}
      </div>
      <div
        className={cn(
          'mt-4 grid grid-cols-1 gap-x-4 gap-y-3 border-t border-slate-200 pt-4',
          !compact && 'sm:grid-cols-2 md:grid-cols-4',
        )}
      >
        <InfoField label="幣別" value={detail.currencyCode || 'TWD'} />
        <InfoField label="總額取整" value={formatCostEstimateRoundingMode(detail.roundingMode)} />
        <InfoField label="明細數" value={String((detail.lines ?? []).length)} />
        <InfoField label="未取整合計" value={formatCostEstimateDecimal(detail.amountSummary?.subtotalAmount)} />
        <InfoField label="總額" value={formatCostEstimateTotal(detail.amountSummary?.totalAmount)} />
        <InfoField label="建立" value={formatDateTimeOrDash(detail.record?.createdAt)} />
        <InfoField label="修改" value={formatDateTimeOrDash(detail.record?.updatedAt)} />
        <InfoField label="備註" value={detail.remark || '-'} wide />
      </div>
    </div>
  </div>
);

CostEstimateMainInfoCard.propTypes = {
  detail: PropTypes.object.isRequired,
  actions: PropTypes.node,
  compact: PropTypes.bool,
};

export default CostEstimateMainInfoCard;
